import { api } from './api'
import type { Event, EventListParams, PaginatedEvents } from '@/types/events'

export const eventsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listEvents: builder.query<PaginatedEvents, EventListParams>({
      query: (params) => {
        const search = new URLSearchParams()
        if (params.type) search.set('type', params.type)
        if (params.page) search.set('page', String(params.page))
        if (params.perPage) search.set('perPage', String(params.perPage))
        return `/events?${search.toString()}`
      },
      providesTags: [{ type: 'Events', id: 'LIST' }],
    }),

    getEvent: builder.query<{ data: Event }, string>({
      query: (id) => `/events/${id}`,
      providesTags: (result) =>
        result ? [{ type: 'Events', id: result.data.id }] : [],
    }),
  }),
})

export const { useListEventsQuery, useGetEventQuery } = eventsApi
